import * as Yup from "yup";

const signupFormSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email"),
  password: Yup.string().min(8),
  repeatPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  phoneNationalNumber: Yup.string().nullable(),
  location: Yup.object().shape({
    latLng: Yup.object().shape({
      lat: Yup.string(),
      lng: Yup.string()
    }),
    fullAddress: Yup.string().nullable()
  }).nullable(),
  firstName: Yup.string(),
  lastName: Yup.string(),
  profilePhoto: Yup.mixed()
});

export default signupFormSchema;